import { EntityCommand, EntityCommandPropertyValues, EntityCommandTypeEnum, IEntityCommand } from "./EntityCommand";
import { EntityCommandInformation } from "./EntityCommandInformation";
import { PartialNullable } from "./Extensions";
import { NAMESPACE } from "./_Namespace";
import { Property } from "./RadObject";
import { PermissionEvaluator } from "./Server/DotNet/SeriouslyRAD.Framework.Data.Entities/Evaluation/Evaluators/PermissionEvaluator";
import { PageManager } from "./Ui/PageManager";

export type EntityCommandNewPropertyValues =
    EntityCommandPropertyValues
    & {
    };

export type EntityCommandNewProperties = {
    [name in keyof EntityCommandNewPropertyValues]: Property<EntityCommandNewPropertyValues[name]>
};

export interface IEntityCommandNew extends IEntityCommand, EntityCommandNewProperties
{
}

export class EntityCommandNew extends EntityCommand<EntityCommandNewPropertyValues> implements IEntityCommandNew
{
    public static override classNamespace = NAMESPACE + "EntityCommandNew";
    public static override className = "EntityCommandNew";

    // #region Static

    // #region Overrides

    public static override createPropertyDefaults(): PartialNullable<EntityCommandNewPropertyValues>
    {
        return {
            ...super.createPropertyDefaults(),
            ...{
                description: "New",
                key: "NEW",
                permission: PermissionEvaluator.permissionLevels.create,
                type: EntityCommandTypeEnum.entitySet,
            }
        };
    }

    // #endregion

    // #endregion

    // #region Instance

    // #region Constructor

    constructor(propertyValues?: PartialNullable<EntityCommandNewPropertyValues>)
    {
        super(propertyValues);
    }

    // #endregion

    // #region Overrides

    protected override _executeAsync(entityCommandInformation: EntityCommandInformation, value: any)
    {
        return (
            super._executeAsync(entityCommandInformation, value)
                .then(() =>
                {
                    if (entityCommandInformation.openRecordInDialog.get())
                        return PageManager.instance?.openPageAsDialogAsync(entityCommandInformation.createEntityUrl());

                    return PageManager.instance?.navigateAsync(entityCommandInformation.createEntityUrl());
                })
        );
    }

    // #endregion

    // #endregion
}

